import { type BaseNotificationItemProps, NotificationItem } from '../components/NotificationItem'

export type EligibilityRemovedProps = BaseNotificationItemProps & {
  type: 'eligibility_removed'
  program: {
    id: string
    displayName: string
    color: string
    iconType?: string
  }
}

export function EligibilityRemoved({ program, ...props }: EligibilityRemovedProps) {
  return (
    <NotificationItem
      {...props}
      title={`${program.displayName} Eligibility Removed`}
      descriptionAddon={
        <p className='flex text-sm text-gray-500'>{`Your Eligibility to work on ${program.displayName} has been removed.`}</p>
      }
    />
  )
}
